import React from 'react'
import ProductDetail from './ProductDetail'

function index() {
    return (
        <ProductDetail />
    )
}

export default index